import { userRolesEnum } from 'Constants/userRoles'

import type { LimitedRolesPermissionsConfig } from 'Portal/src/types/permissions.types'

import { GLOBAL_ROUTE_PATHS } from '../router/Router.constants'

// Configuration for roles with limited permissions.
// Boolean flags indicate access rights.
// Declare only actions that are allowed; omitted actions are considered disallowed for a limited role.
export const limitedRolesPermissionsConfig: LimitedRolesPermissionsConfig = {
  [userRolesEnum.ROLE_PORTAL_ADMIN_HANDOVER]: {
    // Allowed route paths for this limited role
    allowedPaths: [
      GLOBAL_ROUTE_PATHS.organisation.dashboard,
      GLOBAL_ROUTE_PATHS.organisation.employee,
      GLOBAL_ROUTE_PATHS.organisation.employees,
      GLOBAL_ROUTE_PATHS.organisation.employeeOrderNew,
      GLOBAL_ROUTE_PATHS.organisation.orders,
      GLOBAL_ROUTE_PATHS.organisation.order,
      GLOBAL_ROUTE_PATHS.organisation.employeeOrderConfirmation,
      GLOBAL_ROUTE_PATHS.organisation.employeeOrderCustomConfirmation,
    ],

    // Global permissions
    dropdownAclOrganisation: true,
    globalSearch: true,

    // Module-specific permissions
    modules: {
      employees: {
        actions: {
          rentNewDevice: true,
        },
      },

      orderFlow: {
        actions: { allowHandover: true },
      },
    },
  },
}
